import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PortalLoadingProvider from "./components/PortalLoadingProvider";
import {
  applyThemeToDocument,
  getStoredTheme,
} from "../salon-admin/utils/theme";

import "../nyafaz-ep/executive/assets/fonts/local-fonts.css";
import "../nyafaz-ep/executive/index.css";
import "./enterprise-portal-theme.css";

export default function NyafazPortalFlowLayout() {
  useEffect(() => {
    applyThemeToDocument(getStoredTheme());
    const sync = () => applyThemeToDocument(getStoredTheme());
    window.addEventListener("storage", sync);
    window.addEventListener("themechange", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("themechange", sync);
    };
  }, []);

  return (
    <PortalLoadingProvider>
      <Outlet />
    </PortalLoadingProvider>
  );
}
